// File: frontend/src/theme/index.js
// Version: 1.0 (2026-05-11)
// Description: MUI v7 theme objects for the two tenants — MLG (default) and Fitenko (editorial).
// Tenant selection happens in App.js via <ThemeProvider theme={isFitenko ? fitenkoTheme : mlgTheme}>.

import { createTheme } from '@mui/material/styles';

// MLG theme = explicit no-op anchor matching current MUI defaults.
// Explicit so future tweaks have a home AND the App.js conditional is symmetric.
export const mlgTheme = createTheme({
    palette: {
        mode: 'light',
        primary: { main: '#2563eb' },   // tailwind blue-600 — matches MLG audit top-15 hex
        secondary: { main: '#64748b' }, // slate-500
    },
});

// Fitenko theme = палитра §3.1 (fitenko-tokens.css), ДОСЛОВНЫМИ hex.
// IMPORTANT: literal hex values, NOT var(--gold) references — MUI's lighten/darken
// helpers parse the string and choke on CSS var() syntax.
// 🔴 Гарнитуры здесь тоже ЛИТЕРАЛАМИ, не var(--font-ui): MUI прогоняет строку
//    через свои разборщики. Откат смены гарнитуры делается В ДВУХ местах —
//    два токена в styles/fitenko-tokens.css И эти пять литералов.
export const fitenkoTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#C8A653',         // --gold §3.1
            // dark / light / contrastText НЕ ЗАДАНЫ НАРОЧНО: их в §3.1 нет,
            // MUI выводит сам (dark rgb(140,116,58), light rgb(211,183,117),
            // contrastText rgba(0,0,0,0.87) — тёмный текст на золоте, 9.7:1 против 2.16:1 у белого).
        },
        secondary: {
            main: '#687077',         // --ink-muted §3.1 (color="secondary" в коде 0 вхождений)
        },
        background: {
            default: '#F8F7F2',      // --canvas §3.1
            paper: '#FFFFFF',        // --surface §3.1
        },
        text: {
            primary: '#20231F',      // --ink §3.1
            secondary: '#687077',    // --ink-muted §3.1
            disabled: '#858481',     // 🔴 ОСТАТОК: роли "disabled" в §3.1 нет
        },
        divider: '#E5E1D6',          // --line §3.1
        error: { main: '#C84842' },      // --red-accent §3.1
        warning: { main: '#D78416' },    // --amber-accent §3.1
        success: { main: '#0B8B5E' },    // --green-accent §3.1
        info: { main: '#3674D8' },       // --blue-accent §3.1
    },
    typography: {
        fontFamily: '"Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        h1: { fontFamily: '"DM Serif Display", Georgia, serif', fontWeight: 500 },
        h2: { fontFamily: '"DM Serif Display", Georgia, serif', fontWeight: 500 },
        h3: { fontFamily: '"DM Serif Display", Georgia, serif', fontWeight: 500 },
        h4: { fontFamily: '"DM Serif Display", Georgia, serif', fontWeight: 500 },
        button: {
            textTransform: 'uppercase',
            letterSpacing: '0.12em',
            fontWeight: 600,
        },
    },
    shape: { borderRadius: 12 },  // --radius-card §3.1
    components: {
        MuiButton: {
            styleOverrides: {
                root: { borderRadius: 12 },  // ПЕРЕБИВАЕТ shape: без этого радиус §3.1 объявлен и не получен
                containedPrimary: {
                    boxShadow: '0 2px 4px rgba(200, 166, 83, 0.18)',
                    '&:hover': { boxShadow: '0 4px 10px rgba(200, 166, 83, 0.28)' },
                },
            },
        },
    },
});
